<template>
    <div class="w-100 overflow">
        <Navigation pageName="activesessions" />
        <div id="activesessions" class="p-5 w-100 h-100">

            <div class="row mb-2">
                <!-- Campo ricerca a sinistra -->
                <div class="cell-md-3">
                    <input type="text" data-role="input" data-clear-button="true" :placeholder="$t('Search')" v-model="searchTerm" class="w-100">
                </div>

                <!-- Bottone a destra -->
                <div class="cell-md-9 text-right">
                    <a id="refreshactivities" href="#" @click="refreshSessions()" class="button secondary">
                        <i aria-hidden="true" class="mif mif-2x mif-refresh mr-1"></i>
                        {{ $t("Refresh") }}
                    </a>
                </div>
            </div>

            <div v-if="!controls" data-role="activity" data-type="metro" data-style="dark"></div>
            <NoDataAvailable v-else-if="filteredControls == null || Object.keys(filteredControls).length == 0" :message="$t('There are no active sessions')" />

            <table v-else id="controls-list" class="border bg-white compact table w-100 mt-4">
                <thead class="mb-0">
                    <tr class="mb-3">

                        <th class="pl-5" style="vertical-align: middle;">{{ $t("Operator") }}</th>
                        <th class="text-center" style="vertical-align: middle;">{{ $t("Source") }}</th>
                        <th class="text-center" style="vertical-align: middle;">{{ $t("Source infomations") }}</th>

                        <th class="text-center" style="vertical-align: middle;"></th>

                        <th class="text-center" style="vertical-align: middle;">{{ $t("Destination") }}</th>
                        <th class="text-center" style="vertical-align: middle;">{{ $t("Destination infomations") }}</th>
                        <th class="text-center" style="vertical-align: middle;">{{ $t("Start date") }}</th>

                        <th class="text-left" style="vertical-align: middle;"></th>

                    </tr>
                </thead>

                <tbody>
                    <tr class="pt-10" v-if="!controls">
                        <td class="p-6" colspan="8" data-role="activity" data-type="metro" data-style="dark">
                        </td>
                    </tr>
                    <template v-else>
                        <tr v-for="(control, index) in filteredControls" :key="control.id + '-' + index" class="session-row">
                            <td class="text-bold text-left pl-5">
                                {{ control.firstname + " " + control.lastname }}
                            </td>
                            <td class="session-identity text-center">
                                <div class="session-cell-content">
                                    <PCLink :pc="{
                                        id: control.id,
                                        pc_name: control.computer_name,
                                        device: control.device,
                                        os_version_full: control.os_version_full,
                                        av_alert: control.av_alert,
                                        disk_alert: control.disk_alert,
                                        os_patches_alert: control.os_patches_alert,
                                    }" :seeHealth="false" :seeConnectionStatus="false">
                                    </PCLink>
                                    <div v-if="showComputerDescription(control)">{{ control.computer_descr }}</div>
                                    <div v-if="control.organization_name">{{ control.organization_name }}</div>
                                </div>
                            </td>

                            <td class="session-technical text-center">
                                <div class="session-cell-content">
                                    <div class="session-remote-id">{{ IDRemoteWithSpace(control.id_remote) }}</div>
                                    <div v-if="control.version_remote">v. {{ control.version_remote }}</div>
                                    <div v-if="control.os_version_full" :title="control.os_version_full">{{ control.os_version_full }}</div>
                                </div>
                            </td>

                            <td class="session-direction"><span class="mif mif-2x mif-arrow-right text-center"></span></td>

                            <td class="session-identity text-center">
                                <div class="session-cell-content">
                                    <PCLink :pc="{ id: control.target_host_guid, pc_name: control.name_computer_host, device: '', os_version_full: control.host_os_version_full }" :seeHealth="false" :seeConnectionStatus="false">
                                    </PCLink>
                                </div>
                            </td>

                            <td class="session-technical text-center">
                                <div class="session-cell-content">
                                    <div class="session-remote-id">{{ IDRemoteWithSpace(control.target_host_id) }}</div>
                                    <div v-if="control.host_version_remote">v. {{ control.host_version_remote }}</div>
                                    <div v-if="control.host_os_version_full" :title="control.host_os_version_full">{{ control.host_os_version_full }}</div>
                                </div>
                            </td>

                            <td class="text-center">
                                <label v-if="control.dt_start != '' && control.dt_start != null">
                                    {{ control.dt_start.toLocalDate() }} <br>({{ fromNow(control.dt_start) }})
                                </label>
                            </td>

                            <td class="text-left">
                                <button class="bg-transparent button fg-red fg-white" :title="$t('Click to terminate this connection.')" @click="terminateSessionAction(control.id_remote)">
                                    <span class="mif mif-cross"></span>
                                </button>
                            </td>
                        </tr>
                    </template>

                </tbody>
            </table>

        </div>
    </div>

</template>
<script>
import PCLink from './utils/PCLink'
import Navigation from './utils/Navigation.vue';
import NoDataAvailable from "./utils/NoDataAvailable.vue";
import { diffDate, fromNow, insertSpacesEveryThreeDigits } from '../utils/utilitiesmodule';
export default {
    name: "ActiveSessions",
    components: {
        Navigation,
        NoDataAvailable,
        PCLink,
    },

    data() {
        return {
            groups: null,
            filteredgroups: null,
            searchTerm: '',
            controls: null,

            sessions: null,
            users: null,
            groups: null,
            loading: false,
        }
    },
    created() {
        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        //this.$store.commit('SET_LAYOUT', 'nav-layout')
        this.groups = this.$session.getGroups();
        this.users = this.$session.getUsers();

        /*  this.$root.$on("finish", message => {
             var mss = message.split("|");
             self.$root.toast(this.$t(mss[0]), mss[1]);
         }); */
    },
    mounted: function () {

        this.$api.getControls().then(res => {
            this.controls = res.controls;
        });
    },
    computed: {
        filteredControls() {
            if (this.controls == null) {
                return null;
            }

            if (!this.searchTerm) return this.controls;

            const term = this.searchTerm.toLowerCase();

            return this.controls.filter(control => {
                const fullName = (control.firstname + ' ' + control.lastname).toLowerCase();
                const computerName = (control.computer_name || '').toLowerCase();
                const remoteID = (control.id_remote || '').toString().toLowerCase();
                const sessionDetails = [
                    control.computer_descr,
                    control.organization_name,
                    control.version_remote,
                    control.os_version_full,
                    control.host_version_remote,
                    control.host_os_version_full
                ].filter(Boolean).join(' ').toLowerCase();

                return fullName.includes(term) ||
                    computerName.includes(term) ||
                    remoteID.includes(term) ||
                    sessionDetails.includes(term);
            });
        }
    },
    methods: {

        terminateSessionAction(controlid) {

            const self = this;
            const dialogID = Math.floor(100000 + Math.random() * 900000).toString();
            let content = `<div class="mb-3 ml-1">${this.$t('Are you sure you want to end the active session?')}</div>`

            this.$root.$on(dialogID, async ok => {
                try {
                    if (!ok) {
                        return;
                    }

                    // CHIAMATA API PER TERMINATE SESSION
                    self.terminateSession(controlid);


                } finally {
                    self.$root.$off(dialogID);
                }
                return;
            });

            this.$root.openYesNoDialog(dialogID, this.$t("Confirm Session Closure"), content, this.$t("Yes"), this.$t("No"), "js-dialog-close secondary", "js-dialog-close button");
        },

        refreshSessions() {
            this.$api.getControls().then(res => {
                this.controls = res.controls;
            });
        },

        async terminateSession(controlid) {

            const self = this;

            const resultapi = await this.$api.terminateSession(controlid);

            if (resultapi && resultapi.status === 200 && resultapi.data?.message === "sent") {

                self.$root.toast(this.$t('The terminate command was sent successfully.'), "success")

                setTimeout(() => {
                    this.$api.getControls().then(res => {
                        this.controls = res.controls;
                    });
                }, 5000); // 5000 millisecondi = 5 secondi
            } else {
                console.writeError("Errore nella disconnessione", resultapi);
                self.$root.toast(this.$t('An error occurred while sending the command.'), "error")
            }
        },

        // formatta id remote con spazi ogni 3 cifre
        IDRemoteWithSpace(value) {
            return insertSpacesEveryThreeDigits(value);
        },

        showComputerDescription(control) {
            const description = (control.computer_descr || '').trim().toLowerCase();
            const computerName = (control.computer_name || '').trim().toLowerCase();
            return description !== '' && description !== computerName;
        },

        fromNow(date) {
            return fromNow(date, this.$moment);
        },

        diffDate(datestart, dateend) {
            return diffDate(datestart, dateend, this.$moment);
        },

    }
}



</script>

<style scoped>
.session-identity,
.session-technical {
    vertical-align: middle;
    padding-top: 12px;
    padding-bottom: 12px;
}

.session-cell-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.session-identity {
    min-width: 150px;
}

.session-technical {
    min-width: 180px;
    color: #444;
    font-size: 12px;
    line-height: 1.4;
}

.session-endpoint-name {
    font-weight: 600;
    line-height: 1.25;
}

.session-remote-id {
    margin-bottom: 4px;
    color: #666;
    font-size: 11px;
    letter-spacing: .2px;
    font-weight: 800;
}

.session-identity-details {
    margin-top: 5px;
    color: #555;
    font-size: 12px;
    line-height: 1.35;
}

.session-identity-details>div,
.session-technical>div {
    overflow-wrap: anywhere;
}

.session-direction {
    width: 48px;
    padding: 0 12px;
    vertical-align: middle;
    text-align: center;
}

#controls-list tbody .session-row>td {
    border-bottom: 1px solid #d8d8d8;
}

#controls-list tbody .session-row:nth-child(even)>td {
    background-color: #fafafa;
}

#controls-list tbody .session-row:hover>td {
    background-color: #f2f7fc;
}

#controls-list tbody .session-row:last-child>td {
    border-bottom: 0;
}
</style>
